import FormField from "components/FormField";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import React, { useEffect, useRef, useState } from "react";
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";
import axios from "axios";
import Select from "react-select";
import { Button, Grid } from "@mui/material";
import SoftTypography from "components/SoftTypography";
import Quill from "quill";
import "quill/dist/quill.snow.css";
import toast from "react-hot-toast";
import { uploadImageToGhl } from "hook/services";
import PopUp from "./Component/PopUp";
import { FaGoogle } from "react-icons/fa";
import GoogleReviews from "./Component/GoogleReviews";
import { useGooglePlace } from "context/GooglePlaceContext";
import ReactCropModal from "layouts/super-admin/settings/Configurator/components/ReactCropModal/ReactCropModal";

function ContactTab({ formData, handleRefresh }) {
  const AppService = useAppServices();
  const [agency] = useAgencyInfo();
  const [success, setsuccess] = useState("");
  const [businessTypes, setBusinessTypes] = useState([]);
  const [serviceTypes, setserviceTypes] = useState([]);
  const [businessTags, setBusinessTags] = useState([]);
  const [coverImage, setCoverImage] = useState("");
  const [profileImage, setProfileImage] = useState("");
  const [loadingButton, setLoadingButton] = useState(false);
  const { placeId } = useGooglePlace();
  const [currentFormData, setcurrentFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
  });

  // ReactCropModal states
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const [tempImageFile, setTempImageFile] = useState(null);
  const [imageUploading, setImageUploading] = useState(false);
  const [currentImageType, setCurrentImageType] = useState(""); // "profile" or "cover"
  const [coverImageAspectRatio, setCoverImageAspectRatio] = useState(currentFormData?.cover_image_aspect_ratio || "5:2");

  async function GetuploadImage(image_name, access_token) {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: "https://services.leadconnectorhq.com/medias/files?query=" + image_name,
      headers: {
        Authorization: "Bearer " + access_token,
        Version: "2021-07-28",
      },
    };

    const response_data = await axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        return {
          success: true,
          data: response.data.files[0].url,
        };
      })
      .catch((error) => {
        console.log(error);
        return {
          success: false,
          data: error,
        };
      });
    return response_data;
  }

  useEffect(() => {
    if (formData) {
      setcurrentFormData(formData);
      setCoverImageAspectRatio(formData?.cover_image_aspect_ratio || "5:2");
    }
  }, [formData]);

  const GetBusinessTypes = async () => {
    const { response } = await AppService.business_types.get_all_types({
      query: `agency_id=${agency._id}`,
    });
    if (response) {
      setBusinessTypes(
        response.data.map((item) => ({
          label: item.name,
          value: item._id,
        }))
      );
      setserviceTypes(
        response.service_types.map((item) => ({
          label: item.name,
          value: item._id,
        }))
      );
      setBusinessTags(
        response.tags
          .sort((a, b) => a.order - b.order)
          .map((item) => ({
            label: item.name,
            value: item._id,
          }))
      );
    }
  };

  // Sync currentFormData with formData when formData changes
  useEffect(() => {
    GetBusinessTypes();
  }, []);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setcurrentFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setsuccess("");
  };

  const handleSelectChange = (selectedOption, name) => {
    setcurrentFormData({
      ...currentFormData,
      [name]: selectedOption,
    });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingButton(true);

    let profile_image = currentFormData?.profile_image;
    let cover_image = currentFormData?.cover_image;

    // if (e.target.profile_image?.files && e.target.profile_image?.files?.length) {
    //   const image_response = await uploadImageToGhl(e.target.profile_image?.files[0], agency);
    //   if (image_response) {
    //     toast.success("Profile Image Uploaded");
    //     profile_image = image_response.data;
    //   }
    // }

    // if (e.target.cover_image?.files && e.target.cover_image?.files?.length) {
    //   const image_response = await uploadImageToGhl(e.target.cover_image?.files[0], agency);
    //   if (image_response) {
    //     toast.success("Cover Image Uploaded");
    //     cover_image = image_response.data;
    //   }
    // }

    if (selectedGoogleImageProfile) {
      const image_response = await uploadImageToGhl(selectedGoogleImageProfile, agency);
      if (image_response?.success) {
        toast.success("Profile Image Uploaded");
        profile_image = image_response.data;
      }
    }

    if (selectedGoogleImageCover) {
      const image_response = await uploadImageToGhl(selectedGoogleImageCover, agency);
      if (image_response?.success) {
        toast.success("Profile Image Uploaded");
        cover_image = image_response.data;
      }
    }

    const payload = {
      _id: currentFormData?.id,
      first_name: currentFormData?.first_name,
      city: currentFormData?.city,
      website: currentFormData?.website,
      country: currentFormData?.country,
      state: currentFormData?.state,
      zip_code: currentFormData?.zip_code,
      time_zone: currentFormData?.time_zone,
      description: currentFormData?.description,
      address: currentFormData?.address,
      business_type: currentFormData?.business_type,
      service_type: currentFormData?.service_type,
      business_tags: currentFormData?.business_tags,
      phone: currentFormData?.phone,
      google_place_id: placeId,
      profile_image: profile_image,
      cover_image: cover_image,
      cover_image_aspect_ratio: coverImageAspectRatio,
    };

    const { response } = await AppService.accounts.update({ payload });
    if (response) {
      handleRefresh();
      toast.success("Data updated successfully");
      setLoadingButton(false);
    } else {
      toast.error("Error updating Data");
      setLoadingButton(false);
    }
    document.querySelector('input[type="file"]').value = "";
  };

  const fileInputRef = useRef(null);

  const handleImageUpload = async (e, type) => {
    const file = e.target.files[0];
    if (file) {
      setCurrentImageType(type);
      openCropModal(file);
      // Store reference to the file input
      fileInputRef.current = e.target;
    }
  };

  const clearFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const openCropModal = (file) => {
    setTempImageFile(file);
    setCurrentImage(URL.createObjectURL(file));
    setCropModalOpen(true);
  };

  const handleCroppedImage = async (blob) => {
    if (!blob) return;

    setImageUploading(true);
    try {
      const file = new File([blob], "cropped-image.jpg", { type: "image/jpeg" });
      const image_response = await uploadImageToGhl(file, agency);

      if (image_response?.data) {
        // Update the appropriate image based on currentImageType
        if (currentImageType === "profile_image") {
          setProfileImage(image_response.data);
          setcurrentFormData((prev) => ({
            ...prev,
            profile_image: image_response.data,
          }));
        } else if (currentImageType === "cover_image") {
          setCoverImage(image_response.data);
          setcurrentFormData((prev) => ({
            ...prev,
            cover_image: image_response.data,
          }));
        }

        setTempImageFile(null);
        toast.success("Image uploaded successfully!");
      }
    } catch (err) {
      console.error("Image upload failed:", err);
      toast.error("Failed to upload image");
    } finally {
      setImageUploading(false);
      setCropModalOpen(false);
    }
  };

  const quillRef = useRef(null);
  const quillInstance = useRef(null);

  useEffect(() => {
    if (quillRef.current) {
      if (!quillInstance.current) {
        quillInstance.current = new Quill(quillRef.current, {
          theme: "snow",
        });

        quillInstance.current.on("text-change", () => {
          handleChange({
            target: {
              name: "description",
              value: quillInstance.current.root.innerHTML,
            },
          });
        });
      }

      // Check if currentFormData has description and update Quill content
      if (currentFormData?.description && quillInstance.current) {
        // Only update if content is different to avoid cursor position reset
        if (quillInstance.current.root.innerHTML !== currentFormData.description) {
          quillInstance.current.root.innerHTML = currentFormData.description;
        }
      }
    }
  }, [currentFormData?.description]); // Run when description in currentFormData changes // Run only once when the component mounts

  const [googleImages, setGoogleImages] = useState([]);
  const [selectedGoogleImageProfile, setSelectedGoogleImageProfile] = useState("");
  const [selectedGoogleImageCover, setSelectedGoogleImageCover] = useState("");

  const toggleImage = async (imageUrl) => {
    const blob = await fetch(imageUrl).then((res) => res.blob());
    const file = new File([blob], "image.jpg", { type: blob.type });

    if (imageUploadType === "profile") {
      setSelectedGoogleImageProfile(file);
    } else if (imageUploadType === "cover") {
      setSelectedGoogleImageCover(file);
    }

    setGoogleModelOpen(false);
  };

  const [profilePreviewUrl, setProfilePreviewUrl] = useState(null);
  const [coverPreviewUrl, setCoverPreviewUrl] = useState(null);

  useEffect(() => {
    if (selectedGoogleImageProfile instanceof Blob) {
      const url = URL.createObjectURL(selectedGoogleImageProfile);
      setProfilePreviewUrl(url);

      return () => {
        URL.revokeObjectURL(url);
      };
    }
  }, [selectedGoogleImageProfile]);

  useEffect(() => {
    if (selectedGoogleImageCover instanceof Blob) {
      const url = URL.createObjectURL(selectedGoogleImageCover);
      setCoverPreviewUrl(url);

      return () => {
        URL.revokeObjectURL(url);
      };
    }
  }, [selectedGoogleImageCover]);

  const GetGoogleImages = async () => {
    if (!currentFormData?.google_place_id) {
      setGoogleImages([]);
      return;
    }
    const { response } = await AppService.reviews.GetGoogleImages({
      query: `place_id=${currentFormData?.google_place_id}&Apikey=${agency?.google_image_api_key}`,
    });
    if (response) {
      const urls = response?.data || [];
      setGoogleImages(urls);
    }
  };

  useEffect(() => {
    GetGoogleImages();
  }, [currentFormData?.google_place_id]);

  const [googleModelOpen, setGoogleModelOpen] = useState(false);
  const [imageUploadType, setImageUploadType] = useState("");

  const CloseGoogleModel = () => {
    setGoogleModelOpen(false);
  };

  const openGoogleImageModal = (type) => {
    setImageUploadType(type);
    setGoogleModelOpen(true);
  };

  const buttonRef = useRef(null);
  const textRef = useRef(null);
  const buttonRefCover = useRef(null);
  const textRefCover = useRef(null);

  const handleMouseEnter = () => {
    if (buttonRef.current && textRef.current) {
      buttonRef.current.style.width = "200px";
      buttonRef.current.style.paddingRight = "20px";
      textRef.current.style.opacity = "1";
    }
  };

  const handleMouseEnterCover = () => {
    if (buttonRefCover.current && textRefCover.current) {
      buttonRefCover.current.style.width = "200px";
      buttonRefCover.current.style.paddingRight = "20px";
      textRefCover.current.style.opacity = "1";
    }
  };

  const handleMouseLeave = () => {
    if (buttonRef.current && textRef.current) {
      buttonRef.current.style.width = "50px";
      buttonRef.current.style.paddingRight = "10px";
      textRef.current.style.opacity = "0";
    }
  };

  const handleMouseLeaveCover = () => {
    if (buttonRefCover.current && textRefCover.current) {
      buttonRefCover.current.style.width = "50px";
      buttonRefCover.current.style.paddingRight = "10px";
      textRefCover.current.style.opacity = "0";
    }
  };

  return (
    <>
      <div>
        <form onSubmit={handleSubmit}>
          <>
            <Grid item xs={12} mt={3} display={"flex"} alignItems="center" style={{ padding: 0 }}>
              <label
                className="text-black"
                style={{ marginBottom: "10px", display: "flex", gap: "30px", alignItems: "center" }}
              >
                <span>Profile Image</span>
              </label>
            </Grid>
            <Grid item xs={12} display={"flex"} alignItems="center" style={{ padding: 0 }}>
              <div className="custom-upload-pad" style={{ width: "250px", height: "auto", aspectRatio: "3/2" }}>
                <input type="hidden" name="img_1" value={currentFormData?.profile_image} />

                {currentFormData?.profile_image ? (
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      height: "100%",
                      borderRadius: "8px",
                      overflow: "hidden", // ensures button stays within image
                      display: "block",
                      lineHeight: 0,
                    }}
                  >
                    {/* Uploaded Image */}
                    <img
                      src={
                        profilePreviewUrl ||
                        profileImage ||
                        currentFormData?.profile_image ||
                        "https://storage.googleapis.com/msgsndr/s8fbgevCLY2YSeR5r9gH/media/af4db2df-cbda-4d6c-83dc-3e593a49aa96.png"
                      }
                      alt="img_1"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "8px",
                        display: "block",
                        verticalAlign: "top",
                      }}
                    />

                    {/* Remove Button on Top of Image */}
                    <button
                      type="button"
                      onClick={() => {
                        setProfileImage("");
                        setProfilePreviewUrl("");
                        currentFormData.profile_image = "";
                      }}
                      style={{
                        position: "absolute",
                        top: "5px",
                        right: "5px",
                        backgroundColor: "rgba(0,0,0,0.6)",
                        color: "white",
                        border: "none",
                        borderRadius: "50%",
                        width: "24px",
                        height: "24px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      ✕
                    </button>
                  </div>
                ) : (
                  <SoftButton
                    className="img-center"
                    variant="outlined"
                    component="label"
                    color="dark"
                  >
                    <div>
                      <svg
                        width="100"
                        height="30"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M6.38444 3.98444L4.99555 5.68667L4.58611 5.31056L6.66222 2.77778L8.74722 5.325L8.32889 5.69444L6.94 3.98556V8.33333H6.38444V3.98444ZM10.2778 9.44444H3.05556C1.67722 9.44444 0.555556 8.32333 0.555556 6.94444C0.555556 5.73444 1.41944 4.70111 2.61 4.48667L3.04278 4.40889L3.06667 3.97056C3.16944 2.055 4.75056 0.555556 6.66667 0.555556C8.58278 0.555556 10.1639 2.055 10.2656 3.97056L10.29 4.40889L10.7233 4.48667C11.9133 4.70111 12.7778 5.73444 12.7778 6.94444C12.7778 8.32333 11.6561 9.44444 10.2778 9.44444ZM10.8211 3.94C10.7033 1.745 8.89222 0 6.66667 0C4.44111 0 2.62944 1.745 2.51167 3.94C1.08389 4.19722 0 5.44333 0 6.94444C0 8.63167 1.36833 10 3.05556 10H10.2778C11.965 10 13.3333 8.63167 13.3333 6.94444C13.3333 5.44333 12.2494 4.19722 10.8211 3.94Z"
                          fill="#757575"
                        />
                      </svg>
                    </div>
                    <input
                      hidden
                      accept="image/*"
                      type="file"
                      name="profile_image"
                      onChange={(e) => handleImageUpload(e, "profile_image")}
                    />
                  </SoftButton>
                )}
              </div>
              {currentFormData?.profile_image && (
                <>
                  <div
                    className="buttonupload"
                    style={{ marginLeft: "10px", marginTop: "100px", cursor: "pointer" }}
                  >
                    <label>
                      <div>
                        <svg
                          width="14"
                          height="20"
                          viewBox="0 0 14 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M6.38444 3.98444L4.99555 5.68667L4.58611 5.31056L6.66222 2.77778L8.74722 5.325L8.32889 5.69444L6.94 3.98556V8.33333H6.38444V3.98444ZM10.2778 9.44444H3.05556C1.67722 9.44444 0.555556 8.32333 0.555556 6.94444C0.555556 5.73444 1.41944 4.70111 2.61 4.48667L3.04278 4.40889L3.06667 3.97056C3.16944 2.055 4.75056 0.555556 6.66667 0.555556C8.58278 0.555556 10.1639 2.055 10.2656 3.97056L10.29 4.40889L10.7233 4.48667C11.9133 4.70111 12.7778 5.73444 12.7778 6.94444C12.7778 8.32333 11.6561 9.44444 10.2778 9.44444ZM10.8211 3.94C10.7033 1.745 8.89222 0 6.66667 0C4.44111 0 2.62944 1.745 2.51167 3.94C1.08389 4.19722  0 5.44333 0 6.94444C0 8.63167 1.36833 10 3.05556 10H10.2778C11.965  13.3333 8.63167 13.3333 6.94444C13.3333 5.44333 12.2494 4.19722 10.8211 3.94Z"
                            fill="#757575"
                          />
                        </svg>
                      </div>
                      <input
                        hidden
                        accept="image/*"
                        type="file"
                        name="profile_image"
                        onChange={(e) => handleImageUpload(e, "profile_image")}
                      />
                    </label>
                  </div>
                </>
              )}

              {/* Google Upload Button stays same */}
              <button
                type="button"
                ref={buttonRef}
                style={{
                  marginTop: "100px",
                  marginLeft: "10px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  border: "none",
                  backgroundColor: "black",
                  color: "white",
                  padding: "10px",
                  borderRadius: "50px",
                  cursor: "pointer",
                  overflow: "hidden",
                  transition: "width 0.3s ease, padding 0.3s ease",
                  width: "50px",
                  whiteSpace: "nowrap",
                }}
                onClick={() => openGoogleImageModal("profile")}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <FaGoogle size={22} style={{ flexShrink: 0 }} />
                <span
                  ref={textRef}
                  style={{
                    opacity: 0,
                    color: "white",
                    transition: "opacity 0.3s ease",
                  }}
                >
                  Upload from Google
                </span>
              </button>
            </Grid>

            <Grid item xs={12} display={"flex"} alignItems="center" style={{ padding: 0 }}>
              <SoftTypography
                variant="p"
                className="roboto-family"
                style={{ fontSize: "14px", marginTop: "4px" }}
              >
                1MB maximum size. 1:1 ratio. Recommended dimensions: 500 x 500 pixels.
              </SoftTypography>
            </Grid>
          </>
          {/* <div
          style={{ display: "flex", flexDirection: "column", width: "100%", marginBottom: "20px" }}
        >
          <label
            className="text-black"
            style={{ marginBottom: "10px", display: "flex", gap: "30px", alignItems: "center" }}
          >
            <span>Profile Image</span>
            <img
              src={currentFormData?.profile_image}
              alt="cover_image"
              height={70}
              width={70}
              style={{ borderRadius: "50%" }}
            />
          </label>
          <input type="file" name="profile_image" />
        </div> */}

          <>
            <Grid item xs={12} mt={3} display={"flex"} alignItems="center" style={{ padding: 0 }}>
              <label
                className="text-black"
                style={{ marginBottom: "10px", display: "flex", gap: "30px", alignItems: "center" }}
              >
                <span>Cover Image</span>
              </label>
            </Grid>
            <Grid item xs={12} display={"flex"} alignItems="flex-start" style={{ padding: 0 }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                <div className="custom-upload-pad" style={{ width: "250px", height: "auto", aspectRatio: coverImageAspectRatio === "4:1" ? "4/1" : "5/2" }}>
                  <input type="hidden" name="img_1" value={currentFormData?.cover_image} />
                  {currentFormData?.cover_image ? (
                    <div
                      style={{
                        position: "relative",
                        width: "100%",
                        height: "100%",
                        borderRadius: "8px",
                        overflow: "hidden",
                        display: "block",
                        lineHeight: 0,
                      }}
                    >
                      <img
                        src={
                          coverPreviewUrl ||
                          coverImage ||
                          currentFormData?.cover_image ||
                          "https://storage.googleapis.com/msgsndr/s8fbgevCLY2YSeR5r9gH/media/af4db2df-cbda-4d6c-83dc-3e593a49aa96.png"
                        }
                        alt="img_1"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          objectPosition: "center",
                          borderRadius: "8px",
                          display: "block",
                          verticalAlign: "top",
                        }}
                      />
                      <button
                        type="button"
                        onClick={() => {
                          setCoverImage("");
                          setCoverPreviewUrl("");
                          currentFormData.cover_image = "";
                        }}
                        style={{
                          position: "absolute",
                          top: "5px",
                          right: "5px",
                          backgroundColor: "rgba(0,0,0,0.6)",
                          color: "white",
                          border: "none",
                          borderRadius: "50%",
                          width: "24px",
                          height: "24px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        ✕
                      </button>
                    </div>
                  ) : (
                    <SoftButton
                      className="img-center"
                      variant="outlined"
                      component="label"
                      color="dark"
                    >
                      <div>
                        <svg
                          width="100"
                          height="30"
                          viewBox="0 0 14 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M6.38444 3.98444L4.99555 5.68667L4.58611 5.31056L6.66222 2.77778L8.74722 5.325L8.32889 5.69444L6.94 3.98556V8.33333H6.38444V3.98444ZM10.2778 9.44444H3.05556C1.67722 9.44444 0.555556 8.32333 0.555556 6.94444C0.555556 5.73444 1.41944 4.70111 2.61 4.48667L3.04278 4.40889L3.06667 3.97056C3.16944 2.055 4.75056 0.555556 6.66667 0.555556C8.58278 0.555556 10.1639 2.055 10.2656 3.97056L10.29 4.40889L10.7233 4.48667C11.9133 4.70111 12.7778 5.73444 12.7778 6.94444C12.7778 8.32333 11.6561 9.44444 10.2778 9.44444ZM10.8211 3.94C10.7033 1.745 8.89222 0 6.66667 0C4.44111 0 2.62944 1.745 2.51167 3.94C1.08389 4.19722 0 5.44333 0 6.94444C0 8.63167 1.36833 10 3.05556 10H10.2778C11.965 10 13.3333 8.63167 13.3333 6.94444C13.3333 5.44333 12.2494 4.19722 10.8211 3.94Z"
                            fill="#757575"
                          />
                        </svg>
                      </div>
                      <input
                        hidden
                        accept="image/*"
                        type="file"
                        name="cover_image"
                        onChange={(e) => handleImageUpload(e, "cover_image")}
                      />
                    </SoftButton>
                  )}
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "250px" }}>
                  <div>
                    <label style={{ fontSize: "14px", fontWeight: "500", color: "#333", display: "block", marginBottom: "8px" }}>
                      Aspect Ratio
                    </label>
                    <select
                      value={coverImageAspectRatio}
                      onChange={(e) => setCoverImageAspectRatio(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "8px 12px",
                        fontSize: "14px",
                        border: "1px solid #D2D6DA",
                        borderRadius: "8px",
                        backgroundColor: "white",
                        cursor: "pointer"
                      }}
                    >
                      <option value="5:2">5:2 (Recommended: 1750 x 700 pixels)</option>
                      <option value="4:1">4:1 (Recommended: 2000 x 500 pixels)</option>
                    </select>
                  </div>
                  <SoftTypography
                    variant="p"
                    className="roboto-family"
                    style={{ fontSize: "14px", marginTop: "4px" }}
                  >
                    1MB maximum size. Choose ratio between 5:2 or 4:1.
                  </SoftTypography>
                </div>
              </div>
              {currentFormData?.cover_image && (
                <>
                  <div
                    className="buttonupload"
                    style={{ marginLeft: "10px", marginTop: "100px", cursor: "pointer" }}
                  >
                    <label>
                      <div>
                        <svg
                          width="14"
                          height="20"
                          viewBox="0 0 14 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M6.38444 3.98444L4.99555 5.68667L4.58611 5.31056L6.66222 2.77778L8.74722 5.325L8.32889 5.69444L6.94 3.98556V8.33333H6.38444V3.98444ZM10.2778 9.44444H3.05556C1.67722 9.44444 0.555556 8.32333 0.555556 6.94444C0.555556 5.73444 1.41944 4.70111 2.61 4.48667L3.04278 4.40889L3.06667 3.97056C3.16944 2.055 4.75056 0.555556 6.66667 0.555556C8.58278 0.555556 10.1639 2.055 10.2656 3.97056L10.29 4.40889L10.7233 4.48667C11.9133 4.70111 12.7778 5.73444 12.7778 6.94444C12.7778 8.32333 11.6561 9.44444 10.2778 9.44444ZM10.8211 3.94C10.7033 1.745 8.89222 0 6.66667 0C4.44111 0 2.62944 1.745 2.51167 3.94C1.08389 4.19722  0 5.44333 0 6.94444C0 8.63167 1.36833 10 3.05556 10H10.2778C11.965  13.3333 8.63167 13.3333 6.94444C13.3333 5.44333 12.2494 4.19722 10.8211 3.94Z"
                            fill="#757575"
                          />
                        </svg>
                      </div>
                      <input
                        hidden
                        accept="image/*"
                        type="file"
                        name="cover_image"
                        onChange={(e) => handleImageUpload(e, "cover_image")}
                      />
                    </label>
                  </div>
                </>
              )}
              <button
                type="button"
                ref={buttonRefCover}
                style={{
                  marginTop: "100px",
                  marginLeft: "10px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  border: "none",
                  backgroundColor: "black",
                  color: "white",
                  padding: "10px",
                  borderRadius: "50px",
                  cursor: "pointer",
                  overflow: "hidden",
                  transition: "width 0.3s ease, padding 0.3s ease",
                  width: "50px",
                  whiteSpace: "nowrap",
                }}
                onClick={() => openGoogleImageModal("cover")}
                onMouseEnter={handleMouseEnterCover}
                onMouseLeave={handleMouseLeaveCover}
              >
                <FaGoogle size={22} style={{ flexShrink: 0 }} />
                <span
                  ref={textRefCover}
                  style={{
                    opacity: 0,
                    color: "white",
                    transition: "opacity 0.3s ease",
                  }}
                >
                  Upload from Google
                </span>
              </button>
            </Grid>
          </>

          {/* <div
          style={{ display: "flex", flexDirection: "column", width: "100%", marginBottom: "20px" }}
        >
          <label
            className="text-black"
            style={{ marginBottom: "10px", display: "", gap: "30px", alignItems: "center" }}
          >
            <span>Cover Image</span>
            <img
              src={currentFormData?.cover_image}
              alt="cover_image"
              height={70}
              width={70}
              style={{ borderRadius: "50%" }}
            />
          </label>
          <input type="file" name="cover_image" />
        </div> */}
          <div style={{ display: "flex", width: "100%" }}>
            <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
              <label className="text-black">Listing labels</label>
              <Select
                isMulti
                value={currentFormData?.business_tags}
                onChange={(option) => handleSelectChange(option, "business_tags")}
                options={businessTags}
                placeholder="Select option"
                name="business_tags"
              />
            </div>
          </div>
          <div style={{ display: "flex", width: "100%" }}>
            <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">Business Name</label>
                <input
                  className="form-control-agust"
                  label="Business name"
                  onChange={handleChange}
                  placeholder="Name"
                  name="first_name"
                  value={currentFormData?.first_name}
                />
              </SoftBox>
              <SoftBox style={{ margin: " 0px " }}>
                <label className="text-black">City</label>
                <input
                  className="form-control-agust"
                  onChange={handleChange}
                  placeholder="city"
                  name="city"
                  value={currentFormData?.city}
                />
              </SoftBox>
            </div>
            <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">Website</label>
                <input
                  className="form-control-agust"
                  onChange={handleChange}
                  placeholder="website"
                  name="website"
                  value={currentFormData?.website}
                />
              </SoftBox>

              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">Country</label>
                <input
                  className="form-control-agust"
                  onChange={handleChange}
                  placeholder="country"
                  name="country"
                  value={currentFormData?.country}
                />
              </SoftBox>
            </div>
          </div>
          <div style={{ display: "flex", width: "100%" }}>
            <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">State / Prov / Region</label>
                <input
                  className="form-control-agust"
                  onChange={handleChange}
                  placeholder="State / Prov / Region"
                  name="state"
                  value={currentFormData?.state}
                />
              </SoftBox>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">Zip / Postal code</label>
                <input
                  className="form-control-agust"
                  onChange={handleChange}
                  placeholder="Zip / Postal code"
                  name="zip_code"
                  value={currentFormData?.zip_code}
                />
              </SoftBox>
            </div>
            <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">Street address</label>
                <input
                  className="form-control-agust"
                  onChange={handleChange}
                  placeholder="address"
                  name="address"
                  value={currentFormData?.address}
                />
              </SoftBox>

              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">Time Zone</label>
                <input
                  className="form-control-agust"
                  onChange={handleChange}
                  placeholder="time zone"
                  name="time_zone"
                  value={currentFormData?.time_zone}
                />
              </SoftBox>
            </div>
          </div>
          <div style={{ display: "flex", width: "100%" }}>
            <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">Phone </label>
                <input
                  className="form-control-agust"
                  onChange={handleChange}
                  placeholder="Phone number"
                  name="phone"
                  value={currentFormData?.phone}
                />
              </SoftBox>
            </div>
            <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
              <SoftBox style={{ margin: "10px 0px " }}>
                <GoogleReviews formData={formData} enable={true} />
              </SoftBox>
            </div>
          </div>

          {/* business detail textarea */}
          <div style={{ width: "100%", padding: "10px 10px 0px 10px" }}>
            <SoftBox style={{ margin: "10px 0px " }}>
              <label className="text-black">Business Description</label>
              <div ref={quillRef} style={{ height: "250px" }} />
            </SoftBox>
          </div>

          <div style={{ margin: "10px 0px", textAlign: "right" }}>
            <Button
              type="submit"
              color="dark"
              style={{ background: "black", color: "white" }}
              className="px-2 py-1"
              disabled={loadingButton}
            >
              {loadingButton ? "Updating..." : "Update"}
            </Button>
          </div>
        </form>
      </div>

      <PopUp
        open={googleModelOpen}
        handleClose={CloseGoogleModel}
        title={`Select Image From Google for ${imageUploadType}`}
      >
        {googleImages?.length > 0 ? (
          <div
            style={{
              display: "flex",
              gap: "20px",
              padding: "10px",
              flexWrap: "wrap",
              overflowX: "auto",
            }}
          >
            {googleImages.map((imageUrl, index) => (
              <div
                key={index}
                style={{
                  minWidth: "120px",
                  backgroundColor: "#f9f9f9",
                  padding: "10px",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  position: "relative",
                }}
              >
                <img
                  src={imageUrl}
                  alt={`Google place image ${index + 1}`}
                  style={{
                    width: "120px",
                    height: "120px",
                    borderRadius: "8px",
                    objectFit: "cover",
                  }}
                />
                <input
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "20px",
                    zIndex: 1000,
                    width: "20px",
                    height: "20px",
                    cursor: "pointer",
                  }}
                  type="checkbox"
                  onChange={() => toggleImage(imageUrl)}
                />
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-500">No images available.</p>
        )}
      </PopUp>

      <ReactCropModal
        open={cropModalOpen}
        onClose={() => {
          clearFileInput();
          setCropModalOpen(false);
        }}
        currentImage={currentImage}
        onCropComplete={handleCroppedImage}
        onClearFile={clearFileInput}
        aspectRatio={
          currentImageType === "profile_image"
            ? 1 / 1
            : coverImageAspectRatio === "4:1"
            ? 4 / 1
            : 5 / 2
        } // 1:1 for profile (500x500), 5:2 or 4:1 for cover
      />
    </>
  );
}

export default ContactTab;
